import create from '../creator'
import axios from '@/wrapper'
import Constants from '@/constants'
import { isBoolean, isStringSet } from '@/utils'
import DefaultLogo from '@/assets/images/logo.svg'
import ChatSupport from '@/plugins/ChatSupport'
import Vue from 'vue'

const initialState = () => ({
  merchantBanks: [],
  merchantLogo: '',
  merchantLogoUrl: '',
  merchantReturn: false,
  merchantReturnURL: '',
  paymentMessage: '',
  paymentShowLiveChat: false,
  paymentShowMessage: false,
  uniqueBuyerReference: false,
  uniqueSellerReference: false,
  isSettingsLoaded: false,
  isCapitecHighRiskTransaction: false,
  hideChatBotButton: true,
})
const _state = initialState()

const actions = {
  async loadSettings({ commit }, { transactionId, retries = 0 }) {
    const resp = await axios.get(
      `v30/payments/merchant/${transactionId}`,
      {},
      {},
      {
        retries,
      }
    )

    commit('setSettings', resp.data)
    commit('setBankLogos')
    commit('setMerchantLogo', resp.data.merchantLogo)

    return resp
  },

  setSettings({ commit }, { settings }) {
    commit('setSettings', settings)
    commit('setBankLogos')
    commit('setMerchantLogo', settings.merchantLogo)
  },
}

const mutations = {
  setSettings(state, settings) {
    if (!settings.hideChatBotButton) {
      Vue.use(ChatSupport)
    }
    Object.assign(state, initialState())
    Object.assign(state, settings)
    Object.assign(state, {
      isSettingsLoaded: true,
    })
  },
  setBankLogos(state) {
    state.merchantBanks = state.merchantBanks.map(bank => {
      const bankInfo =
        Constants.banks.find(item => item.acquirerCode === bank.acquirerCode) ||
        {}

      return {
        ...bank,
        ...bankInfo,
      }
    })
  },
  setMerchantLogo(state, fileName) {
    state.merchantLogoUrl = DefaultLogo

    if (isStringSet(fileName) && !isBoolean(fileName))
      state.merchantLogoUrl = `${process.env.VUE_APP_LOGO_URL}/${fileName}`
  },
  closeWarning(state) {
    state.paymentShowMessage = false
    state.paymentMessage = ''
  },
}

const _getters = {
  banksList: state => {
    return state.merchantBanks.sort((a, b) => a.sequence - b.sequence)
  },
  isCapitecHighRiskTransaction: state => {
    return state.isCapitecHighRiskTransaction
  },
  canRetryTransaction: (state, getters, rootState) => {
    if (!rootState.appSettings.originalUrl) {
      return false
    }

    if (state.uniqueBuyerReference) {
      return false
    }

    return !state.uniqueSellerReference
  },

  canOpenMerchant: state => {
    if (!state.isSettingsLoaded) {
      return false
    }

    // Check that the merchant settings are defined and not blank
    if (!state.merchantReturn || !state.merchantReturnURL) {
      return false
    }

    if (!state.merchantReturn) {
      return false
    }

    // Check if the URL is actually a URL - using regex
    return Constants.urlRegexp.test(state.merchantReturnURL)
  },
}

export default create(
  {
    namespaced: true,
    state: _state,
    actions,
    mutations,
    getters: _getters,
  },
  initialState()
)
